let exam = {
    state: {
        obj: {
            province_id:'',
            city_id:'',
            city_lng:0,
            city_lat:0,
        }
    },
    mutations: {
        setMainCustomer (state, obj) {
            state.obj = JSON.parse(sessionStorage.getItem('MainCustomer')) || {}

            // let o = state.obj || {}
            // for (let key in obj) {
            //     o[key] = obj[key]
            // }
            state.obj={...state.obj,...obj}
            sessionStorage.setItem('MainCustomer', JSON.stringify(state.obj))
            // state.obj = o
        },
        resetMainCustomer  (state) {
            state.obj = {
                province_id:'',
                city_id:'',
                city_lng:0,
                city_lat:0,
            }
            sessionStorage.setItem('MainCustomer', JSON.stringify({}))
        }
    },

    getters: {
        getMainCustomer  :(state)=>(key)=>{
            if ( !state.obj[key]) {
                state.obj = JSON.parse(sessionStorage.getItem('MainCustomer')) || {}
            }
            return (state.obj[key] || '')
        }
    }
}

export default exam


// WEBPACK FOOTER //
// ./src/store/modules/mainCustomer.js